import { render, staticRenderFns } from "./BagDriverLabel.vue?vue&type=template&id=0f1133ed&scoped=true&"
import script from "./BagDriverLabel.vue?vue&type=script&lang=js&"
export * from "./BagDriverLabel.vue?vue&type=script&lang=js&"
import style0 from "./BagDriverLabel.vue?vue&type=style&index=0&id=0f1133ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1133ed",
  null
  
)

export default component.exports